import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Empezás el día sin saber si va a ser un día bueno o un día difícil.', 'La pastilla tarda una hora en hacer efecto y no entendés por qué.', 'Tu familiar queda “congelado” aunque acaba de tomar la dosis.', 'El neurólogo dice que todo está bien, pero en casa la realidad es otra.', 'Cada comida se convierte en una apuesta: ¿hoy va a interferir o no?', 'Los momentos de rigidez se repiten y no tenés forma de anticiparlos.', 'Llegás al final del día agotada, sin saber qué mejorar mañana.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84">
      <div className="mx-auto max-w-4xl" data-id="element-85">
        <header className="text-center" data-id="element-86">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-87">
            ¿Cuánto tiempo más vas a improvisar el día de tu familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-88">
            Sos una persona que da todo por su familia. Investigás, preguntás y
            no te rendís. Pero hasta ahora, nadie te dio la hoja de ruta
            correcta para este momento de la enfermedad.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-89">
            No es falta de voluntad. Es que te faltaba el sistema correcto.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-91">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-92" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-93">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-94">
          ¿Y si pudieras saber exactamente qué hacer cada día para que la
          pastilla funcione mejor?
        </p>
      </div>
    </section>;
}